import React, { useMemo, useState } from 'react';
import { Button, Classes, FormGroup, H5, InputGroup, Intent } from '@blueprintjs/core';
import { DatePicker } from '@blueprintjs/datetime';
import { formatDate, parseDate } from 'utils/format';
import classNames from 'classnames';
import uuid from 'utils/uuid';

import useEditorContext from '../../../context/editorContext';
import useEditorItemContext from '../../../context/editorItemContext';

const CustomEventPanel = () => {
  const { item, config } = useEditorItemContext();
  const editorContext = useEditorContext();

  const [isValidating, setIsValidating] = useState(false);
  const [description, setDescription] = useState('');

  const minDate = useMemo(() => {
    const value = parseDate(`${item.additionalInfo.initialMonth}-01`, 'YYYY-MM-DD');
    return value;
  }, []);

  const maxDate = useMemo(() => {
    const value = parseDate(`${item.additionalInfo.initialMonth}-01`, 'YYYY-MM-DD');
    value.setMonth(value.getMonth() + (config.numberOfMonths ?? 12));
    value.setHours(value.getHours() - 1);
    return value;
  }, []);

  const [date, setDate] = useState(minDate);

  const handleOnAddEvent = () => {
    setIsValidating(true);

    if (description && date) {
      editorContext.addEvents(item.id, [
        {
          key: uuid(),
          date: formatDate(date, 'YYYY-MM-DD'),
          description,
          type: 'custom',
        },
      ]);

      setIsValidating(false);
      setDescription('');
      setDate();
    }
  };

  const invalidDescription = isValidating && description.length === 0;
  const invalidDate = isValidating && !date;

  return (
    <>
      <H5 className="mb-3">Add a custom event</H5>

      <FormGroup
        label="Description"
        labelFor="description"
        helperText={invalidDescription && 'Please fill the description'}
        intent={invalidDescription ? Intent.DANGER : undefined}
      >
        <InputGroup
          id="description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          intent={invalidDescription ? Intent.DANGER : undefined}
        />
      </FormGroup>

      <FormGroup
        label="Date"
        labelFor="date"
        helperText={invalidDate && 'Please select the date'}
        intent={invalidDate ? Intent.DANGER : undefined}
      >
        <DatePicker
          value={date}
          onChange={setDate}
          className={classNames([Classes.ELEVATION_1, 'd-inline-block'])}
          minDate={minDate}
          maxDate={maxDate}
          reverseMonthAndYearMenus
          dayPickerProps={{
            firstDayOfWeek: item.additionalInfo?.initialDay === 'sunday' ? 0 : 1,
          }}
        />
      </FormGroup>

      <div>
        <Button intent={Intent.SUCCESS} onClick={handleOnAddEvent}>
          Add Event
        </Button>
      </div>
    </>
  );
};

export default CustomEventPanel;
